import type { Components, Theme } from '@mui/material/styles';

export const MuiListItem: Components<Theme>['MuiListItem'] = {
  styleOverrides: {
    root: {
      gap: 'var(--ListItem-gap)',
    },
  },
};
